
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.779","height":"17.659"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#939293"}},[_c('path',{attrs:{"d":"M21.5 6.476a.5.5 0 00-.5.5v7.683a2 2 0 01-2 2H3a2 2 0 01-2-2v-11a2 2 0 012-2h12.968a.5.5 0 000-1H3a3 3 0 00-3 3v11a3 3 0 003 3h16a3 3 0 003-3V6.976a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M11.259 12.059a.5.5 0 00.5-.5v-1.65h1.655a.5.5 0 000-1h-1.655v-1.65a.5.5 0 00-1 0v1.65H9.114a.5.5 0 000 1h1.645v1.65a.5.5 0 00.5.5zM22.639.154a.5.5 0 00-.707-.012l-3.135 3.032V1.547a.5.5 0 00-1 0v2.805a.487.487 0 00.074.247.565.565 0 00.034.05.488.488 0 00.392.2h2.892a.5.5 0 000-1h-1.655L22.628.858a.5.5 0 00.011-.704z"}})])])
          )
        }
      }
    